import { Component, Input } from "@angular/core";
import { DEFAULT_RANGE_PERIOD_FILTER_DATA } from "@va/core-library/period-filter";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";

@Component({
  selector: "app-convert-comps-modal",
  templateUrl: "./convert-comps-modal.component.html",
  styleUrls: ["./convert-comps-modal.component.scss"],
})
export class ConvertCompsModalComponent {
  @Input() userTabId: number;
  @Input() addColTableData: Array<any>;
  @Input() stdLineItems: Array<any>;
  @Input() max;
  @Input() tickers: Array<string>;
  @Input() filterData: any;
  @Input() context: string;
  @Input() marketItemsData: Array<any>;

  YearTypeData = DEFAULT_RANGE_PERIOD_FILTER_DATA;
  compsNameError = "Peer Analysis Table Name cannot be blank.";
  compsName = "";
  compsNameInvalid = false;

  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([exclamationTriangle]);
  }

  onUpdateComp(params) {
    this.addColTableData = params;
  }

  updateYearType(params) {
    this.YearTypeData = params.updatedPeriodData;
  }

  onChangeCompsName() {
    if (this.compsName === "") {
      this.compsNameInvalid = true;
    } else {
      this.compsNameInvalid = false;
    }
  }
}
